export default __webpack_public_path__ + "static/media/marker.454957df.svg";